import React from "react";
import styles from "./Visncare.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Visncare = () => {
  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true,
    vertical: false,
  };

  return (
    <section>
      <div className={styles.heroSection}>
        <div className={styles.Slider_section}>
          <Slider {...settings}>
            <div className={styles.Img_div}>
              <img src="Images/011.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/033.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/044.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/022.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/055.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/066.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/077.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
          </Slider>
        </div>
        <div className={styles.content_section}>
          <div className={styles.tittle}>
            <div className={styles.DeseyneLogo}>
              <img src="Images/Deseyne Logo.webp" alt="Deseyne® product logo" />
            </div>
            <div className={styles.subtitle}>
              <h1>
                Deseyne<span className={styles.spnaR}>® </span>The First Contact
                Lens Delivery System
              </h1>
            </div>
            <p className={styles.titpara}>Fuel Your Ocular Health</p>
            <div className={styles.description}>
              <p className={styles.desc}>
                Combining refractive correction with active ocular therapeutics
              </p>
              {/* <p className={styles.learnMoreText}>LEARN MORE About Deseyne®</p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Visncare;
